import { inject, injectable } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';

@injectable()
class CatalogRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {}

  getIssuersCatalog = async () => {
    const request = new Request('finsight_web.catalog.get_issuers', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getSponsorsCatalog = async () => {
    const request = new Request('finsight_web.catalog.get_sponsors', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default CatalogRepository;
